module.exports = __webpack_public_path__ + "img/img_50.c5cf50db.png";